import { Endpoint } from '../endpoint';
import { CompanyResponse, CompanyId } from '@business/entities/companies';
import {
  FetchLibraryFoldersQuery,
  FormLibraryFolderResponse,
  FormLibraryResponse,
  FormLibraryItemShareItem,
  FormLibraryItemType,
  FormLibraryItemResponse,
} from '@business/entities/formsLibrary';
import { ItemId } from '@business/entities/library';
import { CommonService } from '@business/services';
import { FormLibraryFolderFormData } from '@modules/Forms/AddEditFormLibraryFolder/AddEditFormLibraryFolderModal';
import { MoveFormData } from '@modules/Forms/MoveFormToSharedModal/MoveFormToSharedModal';

export function fetchFolders(params: FetchLibraryFoldersQuery) {
  return Endpoint.get<FormLibraryFolderResponse[]>(`@gc/form-library/folders`, { params });
}

export function fetchFolderItems(params: FetchLibraryFoldersQuery) {
  return Endpoint.get<FormLibraryResponse>(`@gc/form-library/folder-items`, { params });
}

// export function fetchCompany(id: CompanyId) {
//   return Endpoint.get<CompanyResponse>(`@gc/form-library/company/${id}`);
// }

export function createFolder(data: FormLibraryFolderFormData) {
  return Endpoint.post<FormLibraryFolderResponse>(`@gc/form-library/create-folder`, { data });
}

export function udpateFolder(id: string, data: FormLibraryFolderFormData) {
  return Endpoint.patch<FormLibraryFolderResponse>(`@gc/form-library/update-folder/${id}`, { data });
}

export function moveForm(data: MoveFormData) {
  return Endpoint.post<void>(`@gc/form-library/move-form`, { data });
}

export function shareItem(id: ItemId, items: FormLibraryItemShareItem[] = [], type: FormLibraryItemType = FormLibraryItemType.form) {
  return Endpoint.post<FormLibraryFolderResponse | FormLibraryItemResponse>(`@gc/form-library/share/${id}`, { data: { items, type } });
}

export function removeForm(id: ItemId) {
  return Endpoint.delete<void>(`@gc/form-library/item/${id}`, {});
}

export function removeFolder(id: ItemId) {
  return Endpoint.delete<void>(`@gc/form-library/folder/${id}`, {});
}

// export function updateCompany(id: CompanyId, company: Partial<CompanyResponse>) {
//   const formData = CommonService.toFormData(company);
//   return Endpoint.post<CompanyResponse>(`@gc/form-library/${id}`, { formData, hasFiles: true });
// }

// export function deleteCompany(companyId: CompanyId) {
//   return Endpoint.delete<void>(`@gc/form-library/${companyId}`);
// }

// export function updateCompanyContent(id: CompanyId, company: Partial<CompanyResponse>) {
//   return Endpoint.patch<CompanyResponse>(`@gc/form-library/content/${id}`, { data: { ...company } });
// }

// export function removeLogo(id: CompanyId, type: string) {
//   return Endpoint.post<CompanyResponse>(`@gc/form-library/remove-logo/${id}`, { data: { type } });
// }
